/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const REQUESTED_CMM_VERIFICATION = 'REQUESTED_CMM_VERIFICATION';
export const requestedCMMVerification = () => {
  return {
    type: REQUESTED_CMM_VERIFICATION
  };
};

export const RECEIVED_CMM_VERIFICATION = 'RECEIVED_CMM_VERIFICATION ';
export const receivedCMMVerification = (verification) => ({
  type: RECEIVED_CMM_VERIFICATION,
  verification
});

export const ERROR_CMM_VERIFICATION = 'ERROR_CMM_VERIFICATION';
export const errorCMMVerification = (error) => ({
  type: ERROR_CMM_VERIFICATION,
  error
});

export const REQUESTED_CMM_UPDATE = 'REQUESTED_CMM_UPDATE';
export const requestedCMMUpdate = () => {
  return {
    type: REQUESTED_CMM_UPDATE
  };
};

export const RECEIVED_CMM_UPDATE = 'RECEIVED_CMM_UPDATE ';
export const receivedCMMUpdate = (verification) => ({
  type: RECEIVED_CMM_UPDATE,
  verification
});

export const ERROR_CMM_UPDATE = 'ERROR_CMM_UPDATE';
export const errorCMMUpdate = (error) => ({
  type: ERROR_CMM_UPDATE,
  error
});
export const RECEIVED_CMM_UPDATE_STOPMAIL = 'RECEIVED_CMM_UPDATE_STOPMAIL ';
export const receivedCMMUpdateStopMail = () => ({
  type: RECEIVED_CMM_UPDATE_STOPMAIL,
  response:"success"
});

export const ERROR_CMM_UPDATE_STOPMAIL = 'ERROR_CMM_UPDATE_STOPMAIL';
export const errorCMMUpdateStopMail = (error) => ({
  type: ERROR_CMM_UPDATE_STOPMAIL,
  error
});

export const CLEAR_CMM = 'CLEAR_CMM';
export const clearCMM = () => ({
  type: CLEAR_CMM
});
